import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { FormControl } from "@mui/material";
import { TextareaAutosize } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  height: "300px",
  "&::-webkit-scrollbar": {
    width: "0.4em",
  },
  overflowY: "scroll",
  borderRadius: 1,
  outline: "none",
  p: 4,
  marginTop: 3,
};

const theme = createTheme({
  palette: {
    neutral: {
      main: "#F0411A",
      contrastText: "#fff",
    },
    neutralsize: {
      width: "10px",
    },
  },
});

const CourseListModaledit = ({ item, render, setRender }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    setName(item?.name);
    setCategory(item?.category);
    setDescription(item?.description);
  }, [item]);

  // const [age, setAge] = React.useState("");

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };

  const handleUpdateCourse = async () => {
    // if (!checkboxObj) {
    //   toast.warning("please choose channel for the user");
    //   return;
    // }
    // if (!values.name) {
    //   toast.warning("please enter  name");
    //   return;
    // }
    // if (!values.phone) {
    //   toast.warning("please enter  phone");
    //   return;
    // }
    // if (!values.email) {
    //   toast.warning("please enter  email");
    //   return;
    // }
    // if (!values.password) {
    //   toast.warning("please enter  password");
    //   return;
    // }
    let formdata = new FormData();
    formdata.append("image", image);

    try {
      const res = await axios.patch(
        `api/v1/a34jl49u-q4r67p89/courses/${item._id}`,
        { name, category, description, formdata },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            withCredentials: true,
            // Authorization: token,
          },
        }
      );
      console.log(res);
      if (res.status === 200 || res.statusText === "OK") {
        toast.success("success");
        setRender(!render);
        setName("");
        setCategory("");
        setDescription("");
        setImage("");
        handleClose();
        return;
      }
    } catch (err) {
      // toast.error(err);
      console.log(err.response.data.message);
      // toast.error(err.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Button
          onClick={() => {
            handleOpen();
            console.log("gg", item._id);
            // handleOpenUser(row._id);
            // setCheckBoxValue(row.channels);
            // setValues({
            //   ...values,
            //   name: row.name,
            //   email: row.email,
            //   phone: row.phone,
            // });

            // console.log("elem",elem)
          }}
          sx={{ minWidth: "10px !important" }}
          // onClick={handleOpen}
        >
          <EditIcon sx={{ color: "#686868" }} />
        </Button>
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Two Digit Lucky Number
          </Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              sx={{ width: "100%" }}
              id="outlined-search"
              label="Name"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            {/* <TextareaAutosize
              aria-label="minimum height"
              minRows={3}
              placeholder="Minimum 3 rows"
              style={{ width: '100%',marginTop:15 }}
            /> */}
            <TextField
              sx={{ width: "100%", marginTop: 1, marginBottom: 1 }}
              id="outlined-search"
              label="Category"
              type="text"
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
              }}
            />
            {/* <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Year"
              type="number"
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Password"
              type="password"
            /> */}
            <input
              onChange={(e) => {
                setImage(e.target.files[0]);
              }}
              type="file"
            />
            <TextareaAutosize
              aria-label="minimum height"
              minRows={3}
              placeholder="Description"
              style={{ width: "100%", marginTop: 10 }}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
            <ThemeProvider theme={theme}>
              <Button
                onClick={handleUpdateCourse}
                sx={{ marginTop: 3, boxShadow: "none !important" }}
                variant="contained"
                color="neutral"
              >
                Update
              </Button>
            </ThemeProvider>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default CourseListModaledit;
